"use client";

import { getUserFriendlyMessage } from "utils/error-sanitizer";
import { ErrorContent } from "modules/common/components/ErrorContent";

type ErrorProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function ErrorComponent({ error }: ErrorProps) {
  return (
    <ErrorContent
      message={getUserFriendlyMessage(error)}
      primaryLink={{ label: "Return to Homepage", href: "/" }}
    />
  );
}
